// import { getItemWebStorage } from "../features/webStorageSaver";

export async function fetchRoadWeatherStationInfo(weatherStationId: string){
    try {
        // const currentDataBase = localStorage.getItem('geo3.lastEnteredDatabase')
        // const currentApiUrl = getItemWebStorage('currentApiUrl')
        // let url = `${currentApiUrl}/weather/${currentDataBase}/get?type=data&id=${weatherStationId}`
        // временная ссылка до починки погоды в базе GK_Avtodor
        let url = `https://gis.russianhighways.ru/rest.rhw/1.0/weather/rhw/get?type=data&id=${weatherStationId}`
        const response: any = await fetch(url, {
            method: 'GET'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch');
        } else {
            let weatherStationInfo = await response.json()
            return weatherStationInfo
        }
    } catch (error) {
        console.error('Fetch error:', error);
    }
}